module.exports = __webpack_public_path__ + "img/home-img.1458f662.png";